import { queryOptions } from "@tanstack/react-query";
import api from "../core/api";
import { Params } from "../types/params";

export const ASSIGNMENTS_KEYS = {
  all: ["assignments"] as const,
  list: (params: Params) => [...ASSIGNMENTS_KEYS.all, "list", params] as const,
  detail: (id: string) => [...ASSIGNMENTS_KEYS.all, "detail", id] as const,
  detailByType: (id: string, type: string, params: Params) => [...ASSIGNMENTS_KEYS.detail(id), type, params] as const,
  // User-specific assignments (different API endpoint)
  user: {
    all: ["assignments", "user"] as const,
    list: (params: Params) => ["assignments", "user", "list", params] as const,
    detail: (id: string) => ["assignments", "user", "detail", id] as const,
  },
} as const;

export const ASSIGNMENTS_QUERIES = {
  detail: (id: string) => {
    return queryOptions({
      queryKey: ASSIGNMENTS_KEYS.detail(id),
      queryFn: async ({ signal }) => {
        const response = await api.get(`/assignments/${id}`, {
          signal,
        });

        return response.data;
      },
    });
  },
  list: (params: Params) => {
    return queryOptions({
      queryKey: ASSIGNMENTS_KEYS.list(params),
      queryFn: async ({ signal }) => {
        const response = await api.get(`/assignments`, {
          ...params,
          signal,
        });

        return response.data;
      },
    });
  },
  detailByType: (id: string, type: string, params: Params) => {
    return queryOptions({
      queryKey: ASSIGNMENTS_KEYS.detailByType(id, type, params),
      queryFn: async ({ signal }) => {
        const response = await api.get(`/assignments/${id}/${type}`, {
          ...params,
          signal,
        });

        return response.data;
      },
    });
  },
  // User-specific assignment queries
  user: {
    detail: (id: string) => {
      return queryOptions({
        queryKey: ASSIGNMENTS_KEYS.user.detail(id),
        queryFn: async ({ signal }) => {
          const response = await api.get(`/user-assignments/${id}`, {
            signal,
          });

          return response.data;
        },
      });
    },
    list: (params: Params) => {
      return queryOptions({
        queryKey: ASSIGNMENTS_KEYS.user.list(params),
        queryFn: async ({ signal }) => {
          const response = await api.get(`/user-assignments`, {
            ...params,
            signal,
          });

          return response.data;
        },
      });
    },
    all: () => {
      return queryOptions({
        queryKey: ASSIGNMENTS_KEYS.user.all,
        queryFn: async ({ signal }) => {
          const response = await api.get(`/user-assignments`, {
            signal,
          });

          return response.data;
        },
      });
    },
  },
} as const;
